import { useState, useCallback } from "react";
import { dashboardBackendUrl } from "../../config/gateway";

interface Prices {
  itemId: string;
  refId: string;
  updateDate: string;
  productName: string;
  priceVtex: number;
  priceSiesa: number;
  listPriceVtex: string;
  listPriceSiesa: string;
}

interface UseGetPricesReturn {
  prices: Prices[] | null;
  loading: boolean;
  error: string | null;
  totalElements: number;
  fetchPrices: (page: number, size: number) => Promise<void>;
}

const useGetPrices = (): UseGetPricesReturn => {
  const [prices, setPrices] = useState<Prices[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [totalElements, setTotalElements] = useState<number>(0);


  const fetchPrices = useCallback(async (page: number, size: number): Promise<void> => {
    setLoading(true);
    setError(null);

    try {
      const tokenStorage = localStorage.getItem("token");
      const token = tokenStorage ? tokenStorage.replace(/['"]+/g, "") : null;

      if (!token) {
        throw new Error(
          "Token de acceso no encontrado. Inicia sesión primero."
        );
      }

      const response = await fetch(
        dashboardBackendUrl.priceMovements(page, size),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          `Error al obtener precios: ${response.status} - ${response.statusText}`
        );
      }

      const data = await response.json();

      if (!Array.isArray(data?.content)) {
        throw new Error(
          "Formato de respuesta inesperado. Se esperaba un array de precios."
        );
      }

      setPrices(data?.content);
      setTotalElements(data.totalElements);
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : "Error desconocido al realizar la solicitud"
      );
    } finally {
      setLoading(false);
    }
  }, []);

  return { prices, loading, error, fetchPrices, totalElements};
};

export default useGetPrices;
